import type { IconSvgProps } from '@qse/constants'
import * as React from 'react'

export const Logo: React.FC<IconSvgProps> = ({ size = 36, height, ...props }) => (
  <svg fill="none" height={size || height} viewBox="0 0 32 32" width={size || height} {...props}>
    <path
      clipRule="evenodd"
      d="M17.6482 10.1305L15.8785 7.02583L7.02979 22.5499H10.5278L17.6482 10.1305ZM19.8798 14.0457L18.11 17.1983L19.394 19.4511H16.8453L15.1056 22.5499H24.7272L19.8798 14.0457Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const CloseIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 18L18 6M6 6l12 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
)

export const PreviewIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <path
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
)

export const DiscordIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => {
  return (
    <svg height={size || height} viewBox="0 0 24 24" width={size || width} {...props}>
      <path
        d="M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
        fill="currentColor"
      />
    </svg>
  )
}

export const TwitterIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => {
  return (
    <svg height={size || height} viewBox="0 0 24 24" width={size || width} {...props}>
      <path
        d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
        fill="currentColor"
      />
    </svg>
  )
}

export const GithubIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => {
  return (
    <svg height={size || height} viewBox="0 0 24 24" width={size || width} {...props}>
      <path
        clipRule="evenodd"
        d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const MoonFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
)

export const StarIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.9995 2.0835L7.45241 7.2825L1.66675 8.12145L5.85796 12.219L4.85608 17.9168L9.9995 15.1748L15.144 17.9168L14.1495 12.219L18.3334 8.12145L12.5798 7.2825L9.9995 2.0835Z"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
)

export const DataIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_341_1625)">
      <path
        d="M18.3335 4.5835C18.3335 4.5835 18.3334 15.0261 18.3334 15.8335C18.3334 17.2142 14.6025 18.3335 10.0001 18.3335C5.39771 18.3335 1.66676 17.2142 1.66676 15.8335C1.66676 15.0595 1.66675 4.5835 1.66675 4.5835"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M18.3334 12.0835C18.3334 13.4642 14.6025 14.5835 10.0001 14.5835C5.39771 14.5835 1.66675 13.4642 1.66675 12.0835"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M18.3334 8.3335C18.3334 9.7142 14.6025 10.8335 10.0001 10.8335C5.39771 10.8335 1.66675 9.7142 1.66675 8.3335"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M10.0001 6.6665C14.6025 6.6665 18.3334 5.54722 18.3334 4.1665C18.3334 2.78579 14.6025 1.6665 10.0001 1.6665C5.39771 1.6665 1.66675 2.78579 1.66675 4.1665C1.66675 5.54722 5.39771 6.6665 10.0001 6.6665Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_341_1625">
        <rect fill="currentColor" height="20" width="20" />
      </clipPath>
    </defs>
  </svg>
)

export const CloudIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 24 16"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.7344 15.0312H4.26562C3.13828 15.0312 2.07216 14.594 1.26366 13.8001C0.448781 13 0 11.939 0 10.8125C0 9.68605 0.448781 8.62498 1.26366 7.82488C1.90181 7.19825 2.70047 6.79386 3.56306 6.65122C3.56269 6.63219 3.5625 6.61302 3.5625 6.59375C3.5625 3.49213 6.08588 0.96875 9.1875 0.96875C10.3377 0.96875 11.4431 1.31502 12.3841 1.97014C13.0465 2.4313 13.5965 3.02216 14.0054 3.70653C14.6653 3.29717 15.4265 3.07812 16.2188 3.07812C18.3228 3.07812 20.072 4.62622 20.3869 6.64325C21.2687 6.77825 22.0859 7.18611 22.7364 7.82488C23.5512 8.62498 24 9.686 24 10.8125C24 11.939 23.5512 13 22.7364 13.8001C21.9278 14.594 20.8617 15.0312 19.7344 15.0312ZM4.26562 8C2.68894 8 1.40625 9.26169 1.40625 10.8125C1.40625 12.3633 2.68894 13.625 4.26562 13.625H19.7344C21.3111 13.625 22.5938 12.3633 22.5938 10.8125C22.5938 9.26169 21.3111 8 19.7344 8H19.0312V7.29688C19.0312 5.74606 17.7696 4.48438 16.2188 4.48438C15.4797 4.48438 14.7806 4.77125 14.2502 5.29217L13.4934 6.03552L13.1036 5.04884C12.462 3.42458 10.9248 2.375 9.1875 2.375C6.86128 2.375 4.96875 4.26753 4.96875 6.59375C4.96875 6.75987 4.99481 6.93823 5.02238 7.12709L5.14833 8H4.26562Z"
      fill="currentColor"
    />
  </svg>
)

export const TrashIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 4.99984H4.16667M4.16667 4.99984H17.5M4.16667 4.99984V16.6665C4.16667 17.1085 4.34226 17.5325 4.65482 17.845C4.96738 18.1576 5.39131 18.3332 5.83333 18.3332H14.1667C14.6087 18.3332 15.0326 18.1576 15.3452 17.845C15.6577 17.5325 15.8333 17.1085 15.8333 16.6665V4.99984M6.66667 4.99984V3.33317C6.66667 2.89114 6.84226 2.46722 7.15482 2.15466C7.46738 1.8421 7.89131 1.6665 8.33333 1.6665H11.6667C12.1087 1.6665 12.5326 1.8421 12.8452 2.15466C13.1577 2.46722 13.3333 2.89114 13.3333 3.33317V4.99984M8.33333 9.1665V14.1665M11.6667 9.1665V14.1665"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.4"
    />
  </svg>
)

export const HelpMailIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9751 4.47492C14.1664 4.58356 14.393 4.61212 14.6053 4.55435C14.8176 4.49659 14.9985 4.35719 15.1084 4.16658C15.1818 4.03941 15.2876 3.9339 15.4149 3.86073C15.5422 3.78756 15.6866 3.74934 15.8334 3.74992C16.0544 3.74992 16.2664 3.83772 16.4227 3.994C16.579 4.15028 16.6667 4.36224 16.6667 4.58325C16.6667 4.80427 16.579 5.01623 16.4227 5.17251C16.2664 5.32879 16.0544 5.41658 15.8334 5.41658C15.6124 5.41658 15.4004 5.50438 15.2442 5.66066C15.0879 5.81694 15 6.0289 15 6.24992C15 6.47093 15.0879 6.68289 15.2442 6.83917C15.4004 6.99545 15.6124 7.08325 15.8334 7.08325C16.2722 7.08297 16.7032 6.96721 17.083 6.74761C17.4629 6.52801 17.7783 6.21231 17.9975 5.83221C18.2167 5.45212 18.332 5.02102 18.3318 4.58225C18.3316 4.14348 18.216 3.71248 17.9965 3.33256C17.777 2.95264 17.4613 2.63718 17.0813 2.41789C16.7013 2.19859 16.2702 2.08318 15.8314 2.08325C15.3926 2.08332 14.9616 2.19887 14.5816 2.41829C14.2017 2.63771 13.8861 2.95326 13.6667 3.33325C13.6116 3.42836 13.5759 3.53344 13.5616 3.64242C13.5473 3.7514 13.5547 3.86214 13.5833 3.96825C13.612 4.07437 13.6613 4.17377 13.7286 4.26073C13.7958 4.34768 13.8796 4.42048 13.9751 4.47492ZM17.5001 11.2499C17.2791 11.2499 17.0671 11.3377 16.9108 11.494C16.7545 11.6503 16.6667 11.8622 16.6667 12.0833V15.4166C16.6667 15.6376 16.579 15.8496 16.4227 16.0058C16.2664 16.1621 16.0544 16.2499 15.8334 16.2499H4.16675C3.94573 16.2499 3.73377 16.1621 3.57749 16.0058C3.42121 15.8496 3.33341 15.6376 3.33341 15.4166V7.42492L8.23342 12.3333C8.70217 12.8014 9.33758 13.0644 10.0001 13.0644C10.6626 13.0644 11.298 12.8014 11.7667 12.3333L13.1334 10.9666C13.2111 10.8889 13.2727 10.7966 13.3148 10.6951C13.3568 10.5936 13.3785 10.4848 13.3785 10.3749C13.3785 10.265 13.3568 10.1562 13.3148 10.0547C13.2727 9.95319 13.2111 9.86095 13.1334 9.78325C13.0557 9.70555 12.9635 9.64392 12.862 9.60187C12.7604 9.55982 12.6516 9.53818 12.5417 9.53818C12.4319 9.53818 12.3231 9.55982 12.2215 9.60187C12.12 9.64392 12.0278 9.70555 11.9501 9.78325L10.5834 11.1499C10.4276 11.3026 10.2182 11.3881 10.0001 11.3881C9.78195 11.3881 9.57252 11.3026 9.41675 11.1499L4.50841 6.24992H10.8334C11.0544 6.24992 11.2664 6.16212 11.4227 6.00584C11.579 5.84956 11.6667 5.6376 11.6667 5.41658C11.6667 5.19557 11.579 4.98361 11.4227 4.82733C11.2664 4.67105 11.0544 4.58325 10.8334 4.58325H4.16675C3.50371 4.58325 2.86782 4.84664 2.39898 5.31548C1.93014 5.78433 1.66675 6.42021 1.66675 7.08325V15.4166C1.66675 16.0796 1.93014 16.7155 2.39898 17.1844C2.86782 17.6532 3.50371 17.9166 4.16675 17.9166H15.8334C16.4965 17.9166 17.1323 17.6532 17.6012 17.1844C18.07 16.7155 18.3334 16.0796 18.3334 15.4166V12.0833C18.3334 11.8622 18.2456 11.6503 18.0893 11.494C17.9331 11.3377 17.7211 11.2499 17.5001 11.2499ZM15.2417 8.15825C15.1636 8.23572 15.1016 8.32789 15.0593 8.42944C15.017 8.53099 14.9952 8.63991 14.9952 8.74992C14.9952 8.85993 15.017 8.96885 15.0593 9.0704C15.1016 9.17195 15.1636 9.26412 15.2417 9.34158L15.3667 9.44158C15.4132 9.47312 15.4636 9.49834 15.5167 9.51658C15.564 9.54061 15.6145 9.55746 15.6667 9.56658H15.8334C15.9989 9.56755 16.161 9.5192 16.2989 9.4277C16.4369 9.33619 16.5444 9.20569 16.6079 9.05282C16.6714 8.89995 16.6879 8.73164 16.6553 8.56935C16.6228 8.40706 16.5426 8.25814 16.4251 8.14159C16.3465 8.06456 16.2535 8.00385 16.1513 7.96297C16.0492 7.92209 15.94 7.90184 15.8299 7.90339C15.7199 7.90493 15.6113 7.92825 15.5104 7.972C15.4094 8.01574 15.3181 8.07904 15.2417 8.15825Z"
      fill="currentColor"
    />
  </svg>
)

export const AddIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 18 18"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.16675 13.1665H9.83342V9.83317H13.1667V8.1665H9.83342V4.83317H8.16675V8.1665H4.83342V9.83317H8.16675V13.1665ZM9.00008 17.3332C7.8473 17.3332 6.76397 17.1179 5.75008 16.6873C4.73619 16.2429 3.85425 15.6457 3.10425 14.8957C2.35425 14.1457 1.75703 13.2637 1.31258 12.2498C0.882026 11.2359 0.666748 10.1526 0.666748 8.99984C0.666748 7.84706 0.882026 6.76373 1.31258 5.74984C1.75703 4.73595 2.35425 3.854 3.10425 3.104C3.85425 2.354 4.73619 1.76373 5.75008 1.33317C6.76397 0.888726 7.8473 0.666504 9.00008 0.666504C10.1529 0.666504 11.2362 0.888726 12.2501 1.33317C13.264 1.76373 14.1459 2.354 14.8959 3.104C15.6459 3.854 16.2362 4.73595 16.6667 5.74984C17.1112 6.76373 17.3334 7.84706 17.3334 8.99984C17.3334 10.1526 17.1112 11.2359 16.6667 12.2498C16.2362 13.2637 15.6459 14.1457 14.8959 14.8957C14.1459 15.6457 13.264 16.2429 12.2501 16.6873C11.2362 17.1179 10.1529 17.3332 9.00008 17.3332ZM9.00008 15.6665C10.8612 15.6665 12.4376 15.0207 13.7292 13.729C15.0209 12.4373 15.6667 10.8609 15.6667 8.99984C15.6667 7.13873 15.0209 5.56234 13.7292 4.27067C12.4376 2.979 10.8612 2.33317 9.00008 2.33317C7.13897 2.33317 5.56258 2.979 4.27091 4.27067C2.97925 5.56234 2.33341 7.13873 2.33341 8.99984C2.33341 10.8609 2.97925 12.4373 4.27091 13.729C5.56258 15.0207 7.13897 15.6665 9.00008 15.6665Z"
      fill="currentColor"
    />
  </svg>
)

export const SunFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
)

export const HeartFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
)

export const SearchIcon = (props: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export const DeleteIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_313_9217)">
        <path
          d="M3.75 4.16675V18.3334H16.25V4.16675H3.75Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path d="M8.33331 8.33325V13.7499V8.33325Z" fill="currentColor" />
        <path
          d="M8.33331 8.33325V13.7499"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M11.6667 8.33325V13.7499"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1.66669 4.16675H18.3334"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M6.66669 4.16675L8.0371 1.66675H11.9905L13.3334 4.16675H6.66669Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_313_9217">
          <rect fill="currentColor" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const DownloadIconDrop = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8824 14.2985C18.2519 13.3355 18.839 11.596 18.3334 10.0001C17.8278 8.40417 16.2794 7.52983 14.6053 7.53112H13.6382C13.006 5.06729 10.9201 3.2483 8.39315 2.95725C5.86615 2.6662 3.42136 3.96333 2.24557 6.21896C1.06977 8.47458 1.40646 11.2216 3.09217 13.1265"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M10.0035 17.0833L10 9.58325L10.0035 17.0833Z" fill="currentColor" />
      <path
        d="M10.0035 17.0833L10 9.58325"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.652 14.4319L10.0003 17.0836L7.34863 14.4319"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export const RenameIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_313_9201)">
        <path
          clipRule="evenodd"
          d="M10 10.0001V7.91675L16.25 1.66675L18.3333 3.75008L12.0833 10.0001H10Z"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M6.66669 10H3.75002C2.59943 10 1.66669 10.9328 1.66669 12.0833C1.66669 13.2339 2.59943 14.1667 3.75002 14.1667H16.25C17.4006 14.1667 18.3334 15.0994 18.3334 16.25C18.3334 17.4006 17.4006 18.3333 16.25 18.3333H7.50002"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_313_9201">
          <rect fill="currentColor" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CopyIconDrop = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={height ?? size}
      viewBox="0 0 20 20"
      width={width ?? size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.41669 5.17975V3.25513C5.41669 2.60792 5.94135 2.08325 6.58856 2.08325H16.7448C17.392 2.08325 17.9167 2.60792 17.9167 3.25513V13.4114C17.9167 14.0586 17.392 14.5833 16.7448 14.5833H14.7985"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.4114 5.41675H3.25519C2.60798 5.41675 2.08331 5.94141 2.08331 6.58862V16.7449C2.08331 17.3921 2.60798 17.9167 3.25519 17.9167H13.4114C14.0586 17.9167 14.5833 17.3921 14.5833 16.7449V6.58862C14.5833 5.94141 14.0586 5.41675 13.4114 5.41675Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export const StarIconMenu = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.9995 2.0835L7.45241 7.2825L1.66675 8.12145L5.85796 12.219L4.85608 17.9168L9.9995 15.1748L15.144 17.9168L14.1495 12.219L18.3334 8.12145L12.5798 7.2825L9.9995 2.0835Z"
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  )
}

export const UploadFile = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 18.3332H4.16668C3.70644 18.3332 3.33334 17.9601 3.33334 17.4999V2.4999C3.33334 2.03966 3.70644 1.66656 4.16668 1.66656H15.8333C16.2936 1.66656 16.6667 2.03966 16.6667 2.4999V9.99991"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M14.7917 18.3333V12.9166"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M12.9167 14.3749L13.5417 13.7499L14.7917 12.4999L16.0417 13.7499L16.6667 14.3749"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M6.66666 6.6666H13.3333"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="2"
      />
      <path
        d="M6.66666 9.99991H9.99999"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="2"
      />
    </svg>
  )
}

export const NewFileUpload = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 19h2v-4.175l1.6 1.6L16 15l-4-4l-4 4l1.425 1.4L11 14.825zm-7 3V2h10l6 6v14zm9-13V4H6v16h12V9zM6 4v5zv16z"
        fill="currentColor"
      />
    </svg>
  )
}

export const NewFolderUpload = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 17h2v-4.2l1.6 1.6L16 13l-4-4l-4 4l1.4 1.4l1.6-1.6V17Zm-9 3V4h8l2 2h10v14H2Zm2-2h16V8h-8.825l-2-2H4v12Zm0 0V6v12Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CreateNewFolder = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 16h2v-2h2v-2h-2v-2h-2v2h-2v2h2zM4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h6l2 2h8q.825 0 1.413.588T22 8v10q0 .825-.587 1.413T20 20zm0-2h16V8h-8.825l-2-2H4zm0 0V6z"
        fill="currentColor"
      />
    </svg>
  )
}

export const UploadFolder = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66666 3.74999V17.0833L3.74999 8.74999H16.4583V6.24999C16.4583 5.78974 16.0852 5.41666 15.625 5.41666H9.99999L7.91666 2.91666H2.49999C2.03975 2.91666 1.66666 3.28975 1.66666 3.74999Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M16.6667 17.0833L18.3333 8.75H3.67186L1.66666 17.0833H16.6667Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </svg>
  )
}

export const QuestionIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.975 4.47504C14.1663 4.58368 14.3929 4.61224 14.6052 4.55447C14.8175 4.49671 14.9984 4.35732 15.1083 4.16671C15.1818 4.03954 15.2875 3.93402 15.4148 3.86086C15.5421 3.78769 15.6865 3.74946 15.8333 3.75004C16.0543 3.75004 16.2663 3.83784 16.4226 3.99412C16.5789 4.1504 16.6667 4.36236 16.6667 4.58337C16.6667 4.80439 16.5789 5.01635 16.4226 5.17263C16.2663 5.32891 16.0543 5.41671 15.8333 5.41671C15.6123 5.41671 15.4004 5.5045 15.2441 5.66078C15.0878 5.81707 15 6.02903 15 6.25004C15 6.47105 15.0878 6.68302 15.2441 6.8393C15.4004 6.99558 15.6123 7.08337 15.8333 7.08337C16.2721 7.08309 16.7031 6.96734 17.0829 6.74774C17.4628 6.52814 17.7782 6.21243 17.9974 5.83233C18.2166 5.45224 18.3319 5.02115 18.3317 4.58237C18.3316 4.1436 18.2159 3.7126 17.9964 3.33268C17.7769 2.95276 17.4613 2.63731 17.0812 2.41801C16.7012 2.19871 16.2701 2.0833 15.8313 2.08337C15.3926 2.08344 14.9615 2.19899 14.5816 2.41841C14.2016 2.63783 13.8861 2.95338 13.6667 3.33337C13.6116 3.42849 13.5758 3.53356 13.5615 3.64254C13.5472 3.75152 13.5546 3.86226 13.5832 3.96838C13.6119 4.07449 13.6613 4.17389 13.7285 4.26085C13.7957 4.3478 13.8795 4.4206 13.975 4.47504ZM17.5 11.25C17.279 11.25 17.067 11.3378 16.9107 11.4941C16.7545 11.6504 16.6667 11.8624 16.6667 12.0834V15.4167C16.6667 15.6377 16.5789 15.8497 16.4226 16.006C16.2663 16.1622 16.0543 16.25 15.8333 16.25H4.16667C3.94565 16.25 3.73369 16.1622 3.57741 16.006C3.42113 15.8497 3.33333 15.6377 3.33333 15.4167V7.42504L8.23334 12.3334C8.70209 12.8015 9.3375 13.0645 10 13.0645C10.6625 13.0645 11.2979 12.8015 11.7667 12.3334L13.1333 10.9667C13.211 10.8889 13.2727 10.7966 13.3147 10.6951C13.3568 10.5936 13.3784 10.4848 13.3784 10.375C13.3784 10.2652 13.3568 10.1564 13.3147 10.0548C13.2727 9.95331 13.211 9.86107 13.1333 9.78337C13.0556 9.70567 12.9634 9.64404 12.8619 9.60199C12.7604 9.55994 12.6516 9.5383 12.5417 9.5383C12.4318 9.5383 12.323 9.55994 12.2215 9.60199C12.1199 9.64404 12.0277 9.70567 11.95 9.78337L10.5833 11.15C10.4276 11.3027 10.2181 11.3883 10.0001 11.3883C9.78187 11.3883 9.57244 11.3027 9.41667 11.15L4.50833 6.25004H10.8333C11.0543 6.25004 11.2663 6.16224 11.4226 6.00596C11.5789 5.84968 11.6667 5.63772 11.6667 5.41671C11.6667 5.19569 11.5789 4.98373 11.4226 4.82745C11.2663 4.67117 11.0543 4.58337 10.8333 4.58337H4.16667C3.50363 4.58337 2.86774 4.84677 2.3989 5.31561C1.93006 5.78445 1.66667 6.42033 1.66667 7.08337V15.4167C1.66667 16.0797 1.93006 16.7156 2.3989 17.1845C2.86774 17.6533 3.50363 17.9167 4.16667 17.9167H15.8333C16.4964 17.9167 17.1323 17.6533 17.6011 17.1845C18.0699 16.7156 18.3333 16.0797 18.3333 15.4167V12.0834C18.3333 11.8624 18.2455 11.6504 18.0893 11.4941C17.933 11.3378 17.721 11.25 17.5 11.25ZM15.2417 8.15837C15.1636 8.23584 15.1016 8.32801 15.0593 8.42956C15.017 8.53111 14.9952 8.63991 14.9952 8.74992C14.9952 8.85993 15.017 8.96885 15.0593 9.0704C15.1016 9.17195 15.1636 9.26412 15.2417 9.34171L15.3667 9.44171C15.4131 9.47325 15.4636 9.49847 15.5167 9.51671C15.5639 9.54073 15.6145 9.55759 15.6667 9.56671H15.8333C15.9989 9.56767 16.1609 9.51932 16.2988 9.42782C16.4368 9.33632 16.5443 9.20581 16.6078 9.05294C16.6713 8.89995 16.6878 8.73164 16.6552 8.56935C16.6227 8.40706 16.5425 8.25814 16.425 8.14171C16.3464 8.06468 16.2534 8.00398 16.1513 7.96309C16.0491 7.92221 15.9399 7.90196 15.8299 7.90351C15.7198 7.90506 15.6112 7.92838 15.5103 7.97212C15.4093 8.01586 15.318 8.07917 15.2417 8.15837Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const LogoutIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99654 2.5H2.5V17.5H10"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path d="M13.75 13.75L17.5 10L13.75 6.25" fill="currentColor" />
      <path
        d="M13.75 13.75L17.5 10L13.75 6.25"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M6.6665 9.99673H17.4998"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </svg>
  )
}

export const MoveIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2639 8.63974C11.0304 8.38553 10.6351 8.36868 10.3808 8.60218C10.1266 8.83565 10.1097 9.23103 10.3432 9.48525L11.3899 10.625H7.1875C6.84231 10.625 6.5625 10.9048 6.5625 11.25C6.5625 11.5952 6.84231 11.875 7.1875 11.875H11.3899L10.3432 13.0147C10.1097 13.269 10.1266 13.6643 10.3808 13.8978C10.6351 14.1313 11.0304 14.1145 11.2639 13.8602L13.2728 11.6727C13.4924 11.4337 13.4924 11.0663 13.2728 10.8272L11.2639 8.63974Z"
        fill="currentColor"
      />
      <path
        clip-rule="evenodd"
        d="M3.75 1.25C2.02411 1.25 0.625 2.64911 0.625 4.375V14.375C0.625 16.7913 2.58375 18.75 5 18.75H15C17.4163 18.75 19.375 16.7913 19.375 14.375V8.125C19.375 5.70875 17.4163 3.75 15 3.75H10C9.80328 3.75 9.61803 3.65737 9.5 3.5L8.75 2.5C8.15984 1.71311 7.23362 1.25 6.25 1.25H3.75ZM1.875 4.375C1.875 3.33947 2.71447 2.5 3.75 2.5H6.25C6.84016 2.5 7.39591 2.77786 7.75 3.25L8.5 4.25C8.85409 4.72213 9.40984 5 10 5H15C16.7259 5 18.125 6.39913 18.125 8.125V14.375C18.125 16.1009 16.7259 17.5 15 17.5H5C3.27413 17.5 1.875 16.1009 1.875 14.375V4.375Z"
        fill="currentColor"
        fill-rule="evenodd"
      />
    </svg>
  )
}

export const FolderIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => (
  <svg
    fill="#5f6368"
    height={size || height}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </g>
  </svg>
)

export const EmptyStateIcon: React.FC<IconSvgProps> = ({
  size,
  width = 63,
  height = 62,
  ...props
}) => (
  <svg
    fill="none"
    height={size || height}
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.103 35.194a.715.715 0 0 0 0-1.003l-2.188-2.188 2.826-2.826a.715.715 0 0 0 0-1.003.715.715 0 0 0-1.003 0L16.912 31l-2.553-2.553a.715.715 0 0 0-1.003 0 .715.715 0 0 0 0 1.003l2.553 2.553-2.553 2.553a.715.715 0 0 0 0 1.003.715.715 0 0 0 1.003 0l2.553-2.553 2.188 2.188c.365.274.73.274 1.003 0ZM19.83 44.22c-.274.274-.274.73.09 1.004.274.273.73.273 1.003-.092 4.468-4.923 12.127-4.832 16.503-.273a.715.715 0 0 0 1.003 0 .715.715 0 0 0 0-1.003c-5.014-5.106-13.585-5.197-18.6.365Z"
      fill="currentColor"
    />
    <path
      d="M53.93 49.691 56.3 25.53c.091-1.003-.273-2.006-.912-2.735-.638-.73-1.64-1.185-2.644-1.185v-6.291c0-2.371-1.823-4.286-4.194-4.377l-38.385-.547c-2.462 0-4.286 1.915-4.377 4.194v1.641c-1.094.274-1.914 1.003-2.37 2.098-.547.638-.912 1.458-1.094 2.096-.456 1.642-.365 3.374-.183 5.106.73 8.024 1.459 15.956 2.097 23.98.274 3.465 1.186 4.923 6.2 5.197 14.315.73 28.63.638 42.944.365.547 0 1.186 0 1.642-.274.547-.273.911-.82.82-1.368-.273-1.185-2.28-1.003-3.465-1.094.821-.547 1.368-1.459 1.55-2.644ZM10.164 11.853l38.385.547c1.55 0 2.918 1.368 2.827 2.918V21.7H37.972c-1.002 0-2.005-.456-2.735-1.185l-2.097-2.37c-1.094-1.186-2.644-1.916-4.285-1.916h-21.7v-1.458c0-1.733 1.368-3.01 3.009-2.918Zm40.209 39.753H9.252c-1.094 0-2.097-.82-2.188-2.006L4.42 19.876c-.092-1.276.911-2.37 2.188-2.37h22.247c1.276 0 2.462.547 3.282 1.459l2.097 2.37a4.857 4.857 0 0 0 3.739 1.733h14.77c.638 0 1.185.273 1.641.729.456.456.639 1.094.547 1.641L52.562 49.6c-.091 1.094-1.094 2.006-2.188 2.006Z"
      fill="currentColor"
    />
    <path
      d="m40.8 30.818 2.006-2.006a.716.716 0 0 0 0-1.003.716.716 0 0 0-1.003 0l-2.006 2.006-2.553-2.553a.715.715 0 0 0-1.003 0 .715.715 0 0 0 0 1.003l2.553 2.553-2.37 2.37a.715.715 0 0 0 0 1.003.716.716 0 0 0 1.002 0l2.371-2.37 2.553 2.553a.715.715 0 0 0 1.003 0 .715.715 0 0 0 0-1.003L40.8 30.818ZM53.2 6.93c-.82 1.094-1.459 2.188-1.915 3.464-.09.365.091.73.456.82.365.092.73-.09.82-.455.365-1.094.913-2.188 1.642-3.1.273-.274.182-.73-.091-1.003-.274 0-.639 0-.912.273ZM59.035 9.574c-.182-.274-.638-.456-.911-.183l-4.286 2.736c-.273.182-.364.638-.182.911.182.274.638.456.912.183l4.285-2.736c.273-.182.365-.638.182-.911ZM60.312 14.497l-4.833.365c-.364 0-.638.364-.638.73 0 .364.365.637.73.637l4.832-.364c.365 0 .638-.365.638-.73-.091-.364-.364-.638-.73-.638Z"
      fill="currentColor"
    />
  </svg>
)

export const LogoIcon: React.FC<IconSvgProps> = ({ size, width = 85, height = 40, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)" fill="currentColor">
      <path d="M53.996 22.181c-.992.573-2.205.86-3.637.86-1.152 0-2.183-.197-3.1-.596-.917-.4-1.69-.942-2.319-1.643a7.18 7.18 0 0 1-1.447-2.456 9.023 9.023 0 0 1-.508-3.036c0-1.085.167-2.147.508-3.104a7.351 7.351 0 0 1 1.447-2.494 6.676 6.676 0 0 1 2.32-1.673c.916-.407 1.947-.603 3.099-.603 1.152 0 2.198.204 3.107.603.91.4 1.682.965 2.311 1.673a7.425 7.425 0 0 1 1.448 2.494 9.36 9.36 0 0 1 .508 3.104c0 1.115-.167 2.094-.508 3.029a7.435 7.435 0 0 1-1.448 2.463l1.872 1.696-1.53 1.59-2.123-1.9v-.007Zm-.485-3.443c.28-.377.508-.844.675-1.401.167-.558.25-1.236.25-2.027 0-.656-.076-1.289-.22-1.899a4.931 4.931 0 0 0-.705-1.642 3.522 3.522 0 0 0-1.258-1.146c-.515-.286-1.151-.429-1.894-.429-.743 0-1.372.143-1.895.43-.523.286-.94.67-1.258 1.145a5.115 5.115 0 0 0-.705 1.642 8.242 8.242 0 0 0-.22 1.899c0 .655.076 1.236.22 1.83.144.596.38 1.123.705 1.598.326.475.743.851 1.258 1.138.516.286 1.152.43 1.895.43.349 0 .614-.016.796-.046.181-.03.356-.083.523-.166l-1.41-1.273 1.53-1.628 1.706 1.545h.008ZM62.5 19.024c.181.347.424.633.727.844.303.219.652.377 1.061.482.41.106.826.159 1.258.159.296 0 .606-.023.947-.076.334-.045.652-.143.948-.279a2.04 2.04 0 0 0 .735-.572c.197-.241.295-.55.295-.927 0-.407-.129-.73-.386-.98a3.097 3.097 0 0 0-1.016-.625 9.667 9.667 0 0 0-1.424-.437 51.048 51.048 0 0 1-1.615-.414 13.304 13.304 0 0 1-1.636-.512 5.524 5.524 0 0 1-1.425-.784 3.717 3.717 0 0 1-1.016-1.198c-.258-.482-.386-1.062-.386-1.748 0-.768.166-1.432.492-1.997a4.359 4.359 0 0 1 1.296-1.408 5.647 5.647 0 0 1 1.804-.837 7.686 7.686 0 0 1 2.016-.271c.788 0 1.538.09 2.258.264.72.173 1.364.46 1.925.844.56.391 1.008.889 1.334 1.491.326.603.493 1.341.493 2.2h-3.191c-.03-.444-.121-.813-.28-1.107a1.897 1.897 0 0 0-.645-.693 2.673 2.673 0 0 0-.917-.354 5.788 5.788 0 0 0-1.121-.106c-.266 0-.53.03-.796.083-.265.053-.508.15-.727.294a1.96 1.96 0 0 0-.539.52 1.43 1.43 0 0 0-.212.79c0 .295.053.528.167.709.114.18.333.347.66.505.325.15.78.309 1.363.46l2.281.587c.28.053.667.158 1.168.301.5.144.992.377 1.485.701a4.38 4.38 0 0 1 1.273 1.281c.356.535.538 1.22.538 2.057 0 .685-.136 1.318-.401 1.898a4.034 4.034 0 0 1-1.19 1.515c-.523.422-1.175.753-1.956.994-.78.234-1.674.355-2.697.355-.826 0-1.63-.098-2.403-.302a6.15 6.15 0 0 1-2.061-.95 4.613 4.613 0 0 1-1.417-1.65c-.349-.67-.516-1.46-.508-2.38h3.19c0 .505.091.927.273 1.273H62.5ZM84.833 7.79v2.758h-7.92v3.195h7.269v2.546h-7.268v3.654H85v2.758H73.61V7.791H84.833ZM25.653 30.778a12.182 12.182 0 0 1-5.54 1.326c-6.722 0-12.178-5.417-12.178-12.108 0-6.69 5.456-12.1 12.178-12.1s12.179 5.417 12.179 12.108c0 1.688-.349 3.292-.978 4.746l3.115 9.29c3.584-3.609 5.797-8.566 5.797-14.044C40.235 8.951 31.224 0 20.114 0S0 8.95 0 19.996s9.003 19.997 20.113 19.997a20.096 20.096 0 0 0 14.24-5.877l-8.708-3.346.008.008Z" />
      <path d="M24.039 15.875a5.645 5.645 0 0 0-7.942.113 5.566 5.566 0 0 0 .113 7.896 5.634 5.634 0 0 0 6.215 1.085l3.274 3.157a2.08 2.08 0 0 0 2.932-.045 2.052 2.052 0 0 0-.045-2.916l-3.274-3.157a5.558 5.558 0 0 0-1.273-6.14v.007ZM43.88 29.723c0-1.431 1.12-2.614 2.56-2.614.69 0 1.304.27 1.751.693l-.53.482a1.805 1.805 0 0 0-1.22-.482c-1.023 0-1.804.881-1.804 1.921s.788 1.899 1.811 1.899c.85 0 1.57-.565 1.57-1.296h-1.456v-.64h2.281c0 1.785-.962 2.636-2.395 2.636a2.583 2.583 0 0 1-2.576-2.591l.007-.008ZM56.444 32.232l-1.296-1.876h-.576v1.876h-.757V27.2h1.932c1.107 0 1.554.799 1.554 1.59 0 .723-.44 1.484-1.289 1.56l1.327 1.875h-.902l.007.008Zm-1.872-4.34v1.809h.993c.698 0 .986-.37.986-.905s-.319-.904-.811-.904h-1.168ZM62.068 29.723c0-1.431 1.114-2.614 2.553-2.614 1.44 0 2.57 1.183 2.57 2.614 0 1.432-1.122 2.592-2.57 2.592-1.447 0-2.553-1.168-2.553-2.592Zm4.372 0c0-1.04-.78-1.914-1.81-1.914-1.032 0-1.797.874-1.797 1.914s.773 1.891 1.796 1.891c1.023 0 1.811-.859 1.811-1.89ZM72.208 30.5v-3.3h.757v3.292c0 .768.516 1.107 1.107 1.107s1.114-.346 1.114-1.107v-3.293h.758v3.3c0 1.153-.864 1.816-1.872 1.816s-1.864-.663-1.864-1.816ZM83.31 27.2c1.084 0 1.546.798 1.546 1.589 0 .791-.455 1.574-1.546 1.574h-1.273v1.861h-.758v-5.032h2.023l.008.007Zm-.046 2.478c.592 0 .827-.445.827-.89 0-.444-.235-.903-.804-.903H82.03v1.793H83.264Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h85v40H0z" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export const StorageIcon: React.FC<IconSvgProps> = ({
  size,
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1804_3934)">
      <path
        d="M18.3334 4.58325C18.3334 4.58325 18.3333 15.0259 18.3333 15.8333C18.3333 17.214 14.6024 18.3333 10 18.3333C5.39762 18.3333 1.66668 17.214 1.66668 15.8333C1.66668 15.0592 1.66666 4.58325 1.66666 4.58325"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M18.3333 12.0833C18.3333 13.464 14.6024 14.5833 10 14.5833C5.39762 14.5833 1.66666 13.464 1.66666 12.0833"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M18.3333 8.33325C18.3333 9.71396 14.6024 10.8333 10 10.8333C5.39762 10.8333 1.66666 9.71396 1.66666 8.33325"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10 6.66675C14.6024 6.66675 18.3333 5.54746 18.3333 4.16675C18.3333 2.78604 14.6024 1.66675 10 1.66675C5.39762 1.66675 1.66666 2.78604 1.66666 4.16675C1.66666 5.54746 5.39762 6.66675 10 6.66675Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1804_3934">
        <rect fill="currentColor" height="20" width="20" />
      </clipPath>
    </defs>
  </svg>
)

export const KeyIcon: React.FC<IconSvgProps> = ({ size, width = 20, height = 20, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1804_3970)">
      <path
        d="M6.96489 7.32539C6.96286 7.32004 6.96079 7.31469 6.95856 7.30938C6.85001 7.04543 6.59559 6.875 6.31028 6.875C6.31005 6.875 6.30977 6.875 6.3095 6.875C6.02387 6.87531 5.76946 7.04633 5.66137 7.3107C5.65958 7.31508 5.65786 7.31949 5.65618 7.32391L3.74938 12.3305C3.63419 12.633 3.78598 12.9715 4.08841 13.0866C4.39083 13.2018 4.72934 13.05 4.8445 12.7476L5.17567 11.8781H7.43051L7.75805 12.7459C7.84661 12.9806 8.06954 13.1252 8.30633 13.1252C8.37508 13.1252 8.44501 13.113 8.51313 13.0873C8.81587 12.973 8.96872 12.635 8.85442 12.3322L6.96489 7.32539ZM5.622 10.7063L6.30825 8.90441L6.98825 10.7063H5.622Z"
        fill="currentColor"
      />
      <path
        d="M15 6.875C14.6765 6.875 14.4141 7.13734 14.4141 7.46094V12.5391C14.4141 12.8627 14.6765 13.125 15 13.125C15.3236 13.125 15.586 12.8627 15.586 12.5391V7.46094C15.586 7.13734 15.3236 6.875 15 6.875Z"
        fill="currentColor"
      />
      <path
        d="M11.6171 6.875H10.2031C10.0474 6.875 9.89809 6.93699 9.78813 7.04727C9.67863 7.15711 9.61719 7.3059 9.61719 7.46094V12.5391C9.61719 12.8627 9.87953 13.125 10.2031 13.125C10.5267 13.125 10.7891 12.8627 10.7891 12.5391V10.9161C11.0866 10.9145 11.4268 10.913 11.6171 10.913C12.7459 10.913 13.6642 10.0073 13.6642 8.89402C13.6642 7.78074 12.7459 6.875 11.6171 6.875ZM11.6171 9.74109C11.4275 9.74109 11.0918 9.74258 10.7957 9.7441C10.7941 9.43813 10.7917 8.36621 10.7908 8.04688H11.6171C12.0915 8.04688 12.4923 8.4348 12.4923 8.89398C12.4923 9.35316 12.0915 9.74109 11.6171 9.74109Z"
        fill="currentColor"
      />
      <path
        d="M19.707 11.718L18.3998 10.9633C18.4413 10.6247 18.4616 10.3068 18.4616 9.99996C18.4616 9.69316 18.4413 9.37516 18.3998 9.0366L19.707 8.28191C19.8416 8.20422 19.9398 8.07625 19.98 7.92613C20.0203 7.77602 19.9992 7.61609 19.9215 7.48152L17.1418 2.66691C16.98 2.38668 16.6218 2.2907 16.3414 2.45242L15.0397 3.20398C14.5261 2.8241 13.9655 2.5025 13.3656 2.24355V0.734375C13.3656 0.410781 13.1033 0.148438 12.7797 0.148438H7.22035C6.89676 0.148438 6.63442 0.410781 6.63442 0.734375V2.24355C6.03461 2.50246 5.47403 2.82414 4.96035 3.20398L3.65867 2.45246C3.5241 2.37477 3.36422 2.35371 3.21407 2.39391C3.06395 2.43414 2.93598 2.5323 2.85828 2.66691L0.0785967 7.48144C-0.0832002 7.76168 0.0128154 8.12004 0.29305 8.28184L1.60016 9.03652C1.55867 9.37512 1.53836 9.69309 1.53836 9.99992C1.53836 10.3068 1.55867 10.6247 1.60016 10.9633L0.29305 11.718C0.0128154 11.8798 -0.0832002 12.2382 0.0785967 12.5184L2.85825 17.3329C2.93594 17.4675 3.06391 17.5657 3.21403 17.6059C3.36414 17.6461 3.52403 17.6251 3.65864 17.5474L4.96035 16.7959C5.47399 17.1757 6.03461 17.4974 6.63442 17.7563V19.2655C6.63442 19.5891 6.89676 19.8514 7.22035 19.8514H12.7797C13.1033 19.8514 13.3656 19.5891 13.3656 19.2655V17.7563C13.9655 17.4973 14.5261 17.1757 15.0397 16.7959L16.3414 17.5474C16.6218 17.7092 16.98 17.6132 17.1418 17.3329L19.9215 12.5184C19.9992 12.3838 20.0202 12.2239 19.98 12.0738C19.9398 11.9237 19.8416 11.7957 19.707 11.718ZM16.4199 16.2396L15.284 15.5838C15.0727 15.4618 14.808 15.4835 14.6194 15.6382C14.0172 16.1323 13.3285 16.5277 12.5726 16.8133C12.3446 16.8995 12.1938 17.1177 12.1938 17.3614V18.6795H7.80629V17.3614C7.80629 17.1177 7.65543 16.8995 7.42746 16.8133C6.6716 16.5277 5.98297 16.1323 5.38063 15.6382C5.192 15.4835 4.92731 15.4618 4.71602 15.5838L3.58016 16.2396L1.38645 12.4399L2.52926 11.78C2.74016 11.6583 2.85375 11.4188 2.81461 11.1784C2.74442 10.7473 2.71028 10.3618 2.71028 9.99992C2.71028 9.63797 2.74442 9.2525 2.81461 8.82141C2.85375 8.58105 2.74016 8.34156 2.52926 8.2198L1.38645 7.55996L3.58016 3.76027L4.71602 4.41605C4.92727 4.53801 5.192 4.51637 5.38063 4.36164C5.98297 3.8675 6.67164 3.47215 7.42746 3.18652C7.65543 3.10035 7.80629 2.88211 7.80629 2.6384V1.32031H12.1938V2.63844C12.1938 2.88215 12.3446 3.10039 12.5726 3.18656C13.3285 3.47219 14.0171 3.86758 14.6194 4.36164C14.808 4.51637 15.0727 4.53805 15.284 4.41609L16.4199 3.76027L18.6137 7.55992L17.4708 8.21977C17.2599 8.34152 17.1463 8.58102 17.1854 8.82137C17.2557 9.25246 17.2898 9.63797 17.2898 9.99988C17.2898 10.3618 17.2556 10.7473 17.1854 11.1784C17.1463 11.4187 17.2599 11.6583 17.4708 11.78L18.6137 12.4398L16.4199 16.2396Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1804_3970">
        <rect fill="currentColor" height="20" width="20" />
      </clipPath>
    </defs>
  </svg>
)

export const PlusIcon: React.FC<IconSvgProps> = ({ size, width = 20, height = 20, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 20 20"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.16667 14.1666H10.8333V10.8333H14.1667V9.16663H10.8333V5.83329H9.16667V9.16663H5.83334V10.8333H9.16667V14.1666ZM10 18.3333C8.84722 18.3333 7.76389 18.118 6.75 17.6875C5.73611 17.243 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.75695 14.2638 2.3125 13.25C1.88195 12.2361 1.66667 11.1527 1.66667 9.99996C1.66667 8.84718 1.88195 7.76385 2.3125 6.74996C2.75695 5.73607 3.35417 4.85413 4.10417 4.10413C4.85417 3.35413 5.73611 2.76385 6.75 2.33329C7.76389 1.88885 8.84722 1.66663 10 1.66663C11.1528 1.66663 12.2361 1.88885 13.25 2.33329C14.2639 2.76385 15.1458 3.35413 15.8958 4.10413C16.6458 4.85413 17.2361 5.73607 17.6667 6.74996C18.1111 7.76385 18.3333 8.84718 18.3333 9.99996C18.3333 11.1527 18.1111 12.2361 17.6667 13.25C17.2361 14.2638 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 14.2639 17.243 13.25 17.6875C12.2361 18.118 11.1528 18.3333 10 18.3333ZM10 16.6666C11.8611 16.6666 13.4375 16.0208 14.7292 14.7291C16.0208 13.4375 16.6667 11.8611 16.6667 9.99996C16.6667 8.13885 16.0208 6.56246 14.7292 5.27079C13.4375 3.97913 11.8611 3.33329 10 3.33329C8.13889 3.33329 6.5625 3.97913 5.27083 5.27079C3.97917 6.56246 3.33333 8.13885 3.33333 9.99996C3.33333 11.8611 3.97917 13.4375 5.27083 14.7291C6.5625 16.0208 8.13889 16.6666 10 16.6666Z"
      fill="currentColor"
    />
  </svg>
)

export const UploadIcon: React.FC<IconSvgProps> = ({ size, width = 24, height = 24, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 9.5V6.65625V4.5C21 3.67158 20.3285 3 19.5 3H4.5C3.67158 3 3 3.67158 3 4.5V19.5C3 20.3285 3.67158 21 4.5 21H9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M17 12L21 16L17 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M12 16H21"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export const CheckIcon: React.FC<IconSvgProps> = ({ size, width = 20, height = 20, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AppStoreIcon: React.FC<IconSvgProps> = ({
  size,
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    fill="currentColor"
    height={size || height}
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
)

export const PlayStoreIcon: React.FC<IconSvgProps> = ({
  size,
  width = 40,
  height = 40,
  ...props
}) => (
  <svg
    aria-hidden="true"
    height={size || height}
    viewBox="0 0 40 40"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0,0h40v40H0V0z" fill="none" />
    <g>
      <path
        d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
        fill="#EA4335"
      />
      <path
        d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
        fill="#FBBC04"
      />
      <path
        d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
        fill="#4285F4"
      />
      <path
        d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
        fill="#34A853"
      />
    </g>
  </svg>
)

export const MobileIcon: React.FC<IconSvgProps> = ({ size, width = 24, height = 24, ...props }) => (
  <svg
    fill="none"
    height={size || height}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    width={size || width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 18h.01M8 21h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2z" />
  </svg>
)
